import styled from "@emotion/styled";
import {ReactComponent as svgGraphBlue} from "../../../../images/800CallLogs/Resources for Call Logs/GraphBlue.svg"

export const GraphBlueSvg = styled(svgGraphBlue)`
     width: 38px;
     height: 38px;
`;